
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import OrgnizationModules from './organizationManagement/routes';
import Dashboard from "./dashboard/DashboardIndex";
import EmployeeModules from "./employeeManagement/routes";
import GeneralMasterModules from "./masterManagement/general/routes";
import EndOfEmploymentsModules from "./EOEServiceManagement/routes";
import RosterModules from "./rosterManagement/routes";
import AssessmentModules from "./assessmentManagement/routes";
import LeaveModules from "./leaveManagement/routes";
import SystemMasterModules from "./masterManagement/system/routes";
import ExpenseModules from "./expenseManagement/routes";
import TravelManagementModules from "./travelManagement/routes";
import LendManagementModuls from "./lendManagement/routes";
import AttendanceManagementModules from "./attendanceManagement/routes";
import TransferPromotionModules from "./transferAndPromotionManagement/routes";
import PayrollManagementModules from "./payrollManagement/routes";
import PolicyManagementModules from "./policyManagement/routes";
import WorkflowManagementModules from "./workflowManagement/routes";
import ReportsModules from "./reports/routes";
import AuthApp from "./userManagement/auth/routes";
import BaseMuiDataTable from "../wrappers/layout/BaseMuiDataTable";
import TaskManagementModules from "./taskManagement/routes";
import IndexEmployees from "./employeeManagement/companyEmployees/IndexEmployees";
import IndexPayrolls from "./payrollManagement/payrolls/IndexPayrolls";
import IndexAllReports from "./reports/allReports/IndexAllReports";
import GenerateReport from "./reports/allReports/components/GenerateReport";
import GenerateClassBasedReport from "./reports/allReports/components/GenerateClassBasedReport";
import EmployeeProfilePage from "./employeeManagement/companyEmployees/components/EmployeeProfilePage";
import MyWorkInbox from "../containers/components/navigation/MyWorkInbox";
import OnboardingModules from "./onboarding/routes";
import { guardElement } from "@comps/components";
import WhatsNewPage from "./whatsNew/WhatsNewPage";

const ModuleRoutes = () => {
  return (
    <Routes>
      <Route index path="/" element={ <Navigate to="/dashboard" replace /> } />
      <Route path="dashboard" element={ <Dashboard modkey="dashboard" /> } />
      <Route path="onboarding/*" element={ <OnboardingModules modkey="onboarding" /> } />
      <Route path="whats-new" element={ <WhatsNewPage /> } />
      <Route path="whatsnew" element={ <Navigate to="/whats-new" replace /> } />
      <Route index path="user/*" element={ <AuthApp /> } />
      <Route path="organization/*" element={ <OrgnizationModules /> } />
      <Route path="employees/*" element={ <EmployeeModules /> } />
      <Route path="my-profile/:tab?" element={ guardElement(<EmployeeProfilePage self />, "profile") } />
      <Route path="my-space" element={ guardElement(<EmployeeProfilePage self embedded />, "profile") } />
      <Route path="my-space/profile/:tab?" element={ guardElement(<EmployeeProfilePage self embedded />, "profile") } />
      <Route path="my-space/requests" element={ guardElement(<MyWorkInbox />, "myRequests") } />
      <Route path="my-space/approvals" element={ guardElement(<MyWorkInbox approvals />, "myApprovals") } />
      <Route path="user/profile/:tab?" element={ guardElement(<EmployeeProfilePage self />, "profile") } />
      <Route path="people/" element={ guardElement(<IndexEmployees modkey="employeeIndex" />, "employeeIndex") } />
      <Route path="people/reports" element={ guardElement(<IndexAllReports modkey="reportsAll" scope="people" />, "reportsAll") } />
      <Route path="people/reports/generate/:id" element={ guardElement(<GenerateReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="people/reports/generate-class/:id" element={ guardElement(<GenerateClassBasedReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="payroll/" element={ guardElement(<IndexPayrolls modkey="payrolls" />, "payrolls") } />
      <Route path="payroll/reports" element={ guardElement(<IndexAllReports modkey="reportsAll" scope="payroll" />, "reportsAll") } />
      <Route path="payroll/reports/generate/:id" element={ guardElement(<GenerateReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="payroll/reports/generate-class/:id" element={ guardElement(<GenerateClassBasedReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="time/reports" element={ guardElement(<IndexAllReports modkey="reportsAll" scope="time" />, "reportsAll") } />
      <Route path="time/reports/generate/:id" element={ guardElement(<GenerateReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="time/reports/generate-class/:id" element={ guardElement(<GenerateClassBasedReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="admin/reports" element={ guardElement(<IndexAllReports modkey="reportsAll" scope="admin" />, "reportsAll") } />
      <Route path="admin/reports/generate/:id" element={ guardElement(<GenerateReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="admin/reports/generate-class/:id" element={ guardElement(<GenerateClassBasedReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="insights/" element={ guardElement(<IndexAllReports modkey="reportsAll" />, "reportsAll") } />
      <Route path="insights/generate/:id" element={ guardElement(<GenerateReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="insights/generate-class/:id" element={ guardElement(<GenerateClassBasedReport modkey="reportsAll" />, "reportsAll") } />
      <Route path="masters/general/*" element={ <GeneralMasterModules /> } />
      <Route path="masters/system/*" element={ <SystemMasterModules /> } />
      <Route path="eoemanagement/*" element={ <EndOfEmploymentsModules /> } />
      <Route path="roster/*" element={ <RosterModules /> } />
      <Route path="assessment-management/*" element={ <AssessmentModules /> } />
      <Route path="leavemanagement/*" element={ <LeaveModules /> } />
      <Route path="expense-management/*" element={ <ExpenseModules /> } />
      <Route path="travel-management/*" element={ <TravelManagementModules /> } />
      <Route path="lend-management/*" element={ <LendManagementModuls /> } />
      <Route path="attendance/*" element={ <AttendanceManagementModules /> } />
      <Route path="transfer-promotion/*" element={ <TransferPromotionModules /> } />
      <Route path="payrollmanagement/*" element={ <PayrollManagementModules /> } />
      <Route path="policymanagement/*" element={ <PolicyManagementModules /> } />
      <Route path="workflowManagement/*" element={ <WorkflowManagementModules /> } />
      <Route path="reports/*" element={ <ReportsModules /> } />
      <Route path="/export-table-data" element={ guardElement(<BaseMuiDataTable modkey="reportsAll" />, "reportsAll") } />
      <Route path="/taskManagement/*" element={ <TaskManagementModules /> } />

      {/* <Route path="work-sheets/*" element={ <WorkSheetModules /> } /> */ }
    </Routes>
  )

}

export default ModuleRoutes;
